import { getMemberId } from '@trello/authentication';

import type { Traits } from './traits';
import { traitsOverrideState } from './traitsOverrideState';
import { userTraitsSharedState } from './userTraitsSharedState';

// Coalesces trait value from overrides and real traits set for the current member
export const getTraitValueWithOverride = (
  traitName: string,
): Traits[string] | null => {
  const memberId = getMemberId();
  if (!memberId) {
    return null;
  }
  return (
    traitsOverrideState.value[traitName] ??
    userTraitsSharedState.value[memberId]?.attributes.find(
      ({ name }) => name === traitName,
    )?.value ??
    null
  );
};
